import Vue from "vue";
import { updateShippingMethod } from "./cart-requests";
import request from "./superagent";
import tippy from 'tippy.js'
// import updateCartBadge from "./cart-count";


function initShippingInfo() {
    var el = document.getElementById("shipping-info-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var slideshowMain;

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        data: {
            loading: false,
            shippingMethod: el.dataset.shippingMethod,
            shippingDate: null,
            shippingTime: null,
            loadNextDayFrom: null,
            timeslots: [],
        },
        mounted: async function() {
            this.loading = false;

            var dateSlider = document.querySelector(".pickup-moment__date-picker .swiper-container");
            
            if( dateSlider ) {
                slideshowMain = new Swiper( dateSlider, {
                    slidesPerView: 7,
                    slidesPerGroup: 7,
                    navigation: {
                        nextEl: ".pickup-moment__date-picker .swiper-button-next",
                        prevEl: ".pickup-moment__date-picker .swiper-button-prev"
                    },
                    breakpoints: {
                        // when window width is <= 320px
                        320: {
                            slidesPerView: 1
                        },
                        // when window width is <= 480px
                        480: {
                            slidesPerView: 2
                        },
                        // when window width is <= 640px
                        640: {
                            slidesPerView: 3
                        }
                    },
                    on: {
                        reachEnd: async function() {
                            let response = await request.get("/shipping-json" + (this.loadNextDayFrom ? "?from=" + this.loadNextDayFrom : "")).set("Accept", "application/json, text/javascript");
                            this.loadNextDayFrom = response.body.nextDay;
                            Vue.set(app, 'loadNextDayFrom', response.body.nextDay);
                            slideshowMain.appendSlide(response.body.days);
                            tippy('[data-tippy-content]', {
                                arrow: true,
                                arrowType: "sharp",
                                distance: 5,
                                followCursor: true,
                                hideOnClick: false,
                                maxWidth: 300,
                                placement: "bottom-end",
                                theme: 've-shipping',
                                touchHold: true,
                            });
                        },
                        click: async function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            var clickEl = e.target.closest(".day");
                            if( !clickEl.classList.contains('disabled') ) {
                                this.shippingDate = clickEl.dataset.dateString;
                                var activeDay = dateSlider.querySelector('.day.active');
                                if( activeDay !== null ){
                                    activeDay.classList.remove("active");
                                }
                                clickEl.classList.add('active');
                                Vue.set(app, 'shippingDate', clickEl.dataset.dateString);

                                let response = await request.get("/timeslot-json" + (clickEl.dataset.date ? "?date=" + clickEl.dataset.date : "" ) + (clickEl.dataset.specialDay == "true" ? "&specialDay=1" : "")).set("Accept", "application/json, text/javascript");
                                Vue.set(app, 'timeslots', response.body.slots);
                                Vue.set(app, 'shippingTime', null);
                            }
                        }
                    }
                });
            }

        },
        computed: {},
        methods: {
            nextStep: function() {
                
            },
            changeShippingMethod: async function(shippingMethodHandle) {
                // TODO: new action with validation on allowed cities?
                let result = await updateShippingMethod(token, shippingMethodHandle);
                if (result.body.error) {
                    alert(result.body.errors);
                } else {
                    this.shippingMethod = shippingMethodHandle;
                }
            },
            setShippingTime: function(timeslot) {
                this.shippingTime = timeslot;
            }
        },
        watch: {}
    });
    // window.cart = app;
}

export default function init() {
    initShippingInfo();
}
